
import { computed, defineComponent, PropType } from 'vue'

// components
import Cheap from '@/common/components/UI/Cheap/index.vue'

// constants
import { TRIPS_STATUSES } from '@/core/constants/tms.constants'

// module components
import TtnTimer from '@/modules/TMSModule/components/TtnTimer/index.vue'

import { formatDateWithTimeFromBackend } from '@/common/helpers/formatDate'

export default defineComponent({
    props: {
        row: {
            type: Object as PropType<any>,
            default: null,
        },
        column: {
            type: Object as PropType<any>,
            default: null,
        },
        index: {
            type: Number,
            required: true,
        },
    },
    components: { Cheap, TtnTimer },
    setup(props) {
        const getCheapTitle = computed(() => {
            return props.row && props.row.isDelayed ? 'Опаздывает' : props.row.status.name
        })

        const getCheapClass = computed(() => {
            let className = 'small '

            if (props.row && props.row.isDelayed) {
                className += 'red'
            } else if (props.row && props.row.status) {
                className += TRIPS_STATUSES[props.row.status.id - 1]
            }

            return className
        })

        const isDirection = computed(() => {
            return (
                props.column &&
                props.row &&
                props.column.key === 'direction' &&
                props.row.fromCity &&
                props.row.toCity
            )
        })

        return {
            getCheapTitle,
            getCheapClass,
            isDirection,
            //
            TRIPS_STATUSES,
            formatDateWithTimeFromBackend
        }
    },
})
